import { IAddress } from 'lib/dfl-address-form-mui/interfaces';
import { ADDRESS_COUNTRY_CODE } from '../settings/address-location';

export const getAddress = (address?: IAddress) => {
  if (!address) return '';

  const street = [address.address1, address.address2].filter(Boolean).join(', ');

  return [street, address.city, address.state, address.country || ADDRESS_COUNTRY_CODE].filter(Boolean).join(', ');
};
